<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("CUSTOMERS.EDIT_CUSTOMER") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <customer-form
              :loading="loading"
              :customerData="customer"
              :formErrors="formErrors"
              @customerSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerForm from "./partials/CustomerForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultCustomer from "./defaultCustomer";

export default {
  layout: "DashboardLayout",

  components: { CustomerForm },

  mixins: [alertLeave],

  data() {
    return {
      customer: cloneDeep(defaultCustomer),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("customers/get", id);
        this.customer = this.$store.getters["customers/customer"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List Customers" });
    },

    viewCustomer() {
      this.alertLeave = false;
      this.$router.push({
        name: "View Customer",
        params: { id: this.customer.id },
      });
    },

    async handleSubmit(customer) {
      this.loading = true;
      const customerData = cloneDeep(customer);

      try {
        await this.$store.dispatch("customers/update", customerData);
        this.$notify({
          type: "success",
          message: this.$t("CUSTOMERS.CUSTOMER_UPDATED"),
        });
        this.viewCustomer();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
